import { ApprovalsTasksRequisitionResponse } from '@Types/api/approvalsList';
import { parseDateTime } from '@Utils/transformDateTime';

import { RequestTypeCodes } from '@Enum/index';
import { TypeDict } from '@Types/index';

import { ColumnDataType } from './type';

const DATE_FORMAT = 'DD/MM/YYYY [at] hh:mm A';

export const dataSourceMap = (
  data: ApprovalsTasksRequisitionResponse[],
  findRequestTypeBy: (
    criteria: string | number,
    searchBy: 'codeDesc' | 'codeNum' | 'code'
  ) => TypeDict
): Array<ColumnDataType> => {
  return data?.map((taskData) => {
    return {
      key: taskData.taskId,
      taskData,
      taskId: taskData.taskId,
      created: parseDateTime(taskData.created, DATE_FORMAT),
      requestNo: taskData.reqNo,
      headerDesc: taskData.description,
      remarks: taskData.remarks,
      requestId: taskData.reqId,
      requestTypeId: findRequestTypeBy(RequestTypeCodes.REQUISITION, 'codeNum')
        ?.codeDesc,
      employee: taskData.employeeName,
      company: taskData.companyName || '',
      lastUpdated: parseDateTime(taskData.updated, DATE_FORMAT),
      statusId: taskData.statusId,
      action: '',
    };
  });
};
